import { NgModule } from '@angular/core';

import { TranslatePipe } from './translate.pipe';
import { VcDatePipe } from './date-format.pipe';

/**
 * The i18n pipes, packaged so every module can have them.
 *
 * They cannot just be declared in AppModule: the admin area is LAZY-LOADED, and a
 * lazily-loaded module gets its own template scope — a pipe declared in AppModule
 * is invisible there and fails at build time with NG8004. Declaring them twice
 * would work and is the wrong answer: a pipe can only be declared in one module,
 * so the second declaration would have to be a copy of the class.
 *
 * TranslationService and PreferencesService stay `providedIn: 'root'` so the lazy
 * module shares the SAME instances — a second dictionary cache in the admin area
 * would fetch everything twice and could drift a language behind.
 */
@NgModule({
  declarations: [TranslatePipe, VcDatePipe],
  exports: [TranslatePipe, VcDatePipe],
})
export class I18nModule {}
